import { Inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable} from 'rxjs';
import { APP_CONFIG } from '../config/app-config.service';
import { IAppConfig } from '../config/app-config.model';
import { LanguageService } from '../language.service';
import { LogService } from '../log.service';

@Injectable()
export class ApiUrlInterceptor implements HttpInterceptor {
    private apiBaseUrl = '';
    public constructor(
        @Inject(APP_CONFIG) protected config: IAppConfig,
        private languageService: LanguageService,
        private log: LogService,
    ){
        this.apiBaseUrl = config.apiServer.endpoint;
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if(/i18n/.test(req.url)){
            return this.languageService.handleRequest(req, next);
        }

        this.log.log(`ApiUrlInterceptor> ${(new Date()).toLocaleTimeString()}: ${req.method} ${req.url}, Language=${this.languageService.getCurrentCultureCode()}`);
        if(req.url.indexOf('http') !== -1 || /^\.\//i.test(req.url)){
            return next.handle(req);
        }
        const modifyRequest = req.clone({
            url: `${this.apiBaseUrl}/${req.url}`,
            withCredentials: true,
            headers: req.headers.set('clientid', this.config.apiServer.clientId)
                                .set('Application', this.config.application)
                                .set('Content-Language', this.languageService.getCurrentCultureCode())
        });
        return next.handle(modifyRequest);
    }
}